import type { AuthType, UserInfoResponse } from "@/api/types";

/** 后端未返回 authType 时默认 email；后端接入后移除默认值即可 */
const DEFAULT_AUTH_TYPE: AuthType = "email";

export function normalizeUserInfo(data: UserInfoResponse): UserInfoResponse {
  return {
    ...data,
    authType: data.authType ?? DEFAULT_AUTH_TYPE,
  };
}
